var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'checkInputComponent',
    'el-form-item',
    _vm.errMsg ? 'is-error' : 'is-success' ]},[_c('el-input',_vm._b({attrs:{"type":"text","size":"mini"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},'el-input',_vm.$attrs,false)),(_vm.errMsg)?_c('div',{staticClass:"el-form-item__error"},[_vm._v(_vm._s(_vm.errMsg))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }